import type { UiSlice, SliceCreator } from "@/state";

export const createUiSlice: SliceCreator<UiSlice> = (set) => ({
  hostEl: null,
  setHostEl: (el) => set({ hostEl: el }, false, "ui/setHostEl"),

  portalContainer: null,
  setPortalContainer: (el) =>
    set({ portalContainer: el }, false, "ui/setPortalContainer"),

  menuAnchorEl: null,
  setMenuAnchorEl: (el) =>
    set({ menuAnchorEl: el }, false, "ui/setMenuAnchorEl"),

  triggerEl: null,
  setTriggerEl: (el) => set({ triggerEl: el }, false, "ui/setTriggerEl"),

  uiVisible: false,
  setUiVisible: (v) => set({ uiVisible: v }, false, "ui/setUiVisible"),
});
